import { render, staticRenderFns } from "./InputFormat.vue?vue&type=template&id=514cce1a"
import script from "./InputFormat.vue?vue&type=script&lang=js"
export * from "./InputFormat.vue?vue&type=script&lang=js"
import style0 from "./InputFormat.vue?vue&type=style&index=0&id=514cce1a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports